import { paymentStatusTone, formatPaymentStatusLabel } from './paymentStatusDisplay'

const TONE_CLASS: Record<ReturnType<typeof paymentStatusTone>, string> = {
  success:
    'bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-950/40 dark:text-emerald-300 dark:border-emerald-800/60',
  warning:
    'bg-amber-50 text-amber-800 border-amber-200 dark:bg-amber-950/40 dark:text-amber-300 dark:border-amber-800/60',
  error:
    'bg-rose-50 text-rose-700 border-rose-200 dark:bg-rose-950/40 dark:text-rose-300 dark:border-rose-800/60',
  info:
    'bg-sky-50 text-sky-700 border-sky-200 dark:bg-sky-950/40 dark:text-sky-300 dark:border-sky-800/60',
  neutral:
    'bg-slate-100 text-slate-600 border-slate-200 dark:bg-zinc-800 dark:text-zinc-300 dark:border-zinc-700',
}

export function PaymentStatusBadge({ status }: { status?: string | null }) {
  const label = formatPaymentStatusLabel(status)
  const tone = paymentStatusTone(status)
  return (
    <span
      data-testid="order-pay-status"
      data-tone={tone}
      className={`inline-flex items-center justify-center whitespace-nowrap px-2.5 py-0.5 rounded-full text-[10px] font-semibold tracking-wide border ${TONE_CLASS[tone]}`}
    >
      {label}
    </span>
  )
}
